// window._ = require('lodash');

try {
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
    require('bootstrap-datepicker');
} catch (e) {
}

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.token = document.head.querySelector('meta[name="csrf-token"]');

// if (token) {
//     window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
// } else {
//     console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
// }

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'your-pusher-key'
// });

window.Vue = require('vue');

window.app = {};

$document = $(document);

app.nprogress = require('nprogress');
app.log = require('./log');
app.i18n = require('./i18n');
app.url = require('./url');
app.string = require('./string');
app.number = require('./number');
app.date = require('./date');
app.routing = require('./routing').instance;
app.vueMixins = {
    ajax: require('./vue_mixins/ajax').default,
};

$document.on('change', '.js-submit-on-change', function () {
    app.nprogress.start();
    $(this).parent('form').submit();
});